import { Post } from '../instance';
import { PromotionParams } from './types';

export const chat = {
	postPromotion: async <T = any>(params: PromotionParams): Promise<T> => {
		const response = await Post<T>(`/chats/promotions`, params);
		return response.data;
	},
};
